import { useState } from "react";
import NoImage from "../assets/images/no-image.webp";

const Gallery = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const mainImage = images.length > 0 ? images[currentIndex].url : NoImage;
  const isNoImage = mainImage === NoImage;

  const openModal = () => {
    if (!isNoImage) {
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev > 0 ? prev - 1 : images.length - 1));
  };

  const handleNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev < images.length - 1 ? prev + 1 : 0));
  };

  return (
      <>
        <div className="grid gap-2 h-[400px] sm:h-[400px] md:h-[450px] lg:h-[550px] xl:h-[600px] xl:flex">
          <div className="flex-1">
            <img
                src={mainImage}
                alt="Main"
                className={`w-full object-cover rounded-md ${
                    isNoImage
                        ? "h-[400px] sm:h-[400px] md:h-[450px] lg:h-[550px] xl:h-[600px]"
                        : "2xl:h-full h-[300px] sm:h-[320px] md:h-[340px] lg:h-[400px] xl:h-[600px]"
                }`}
                onClick={openModal}
            />
          </div>
          {images.length > 1 && (
              <div className="flex flex-row xl:flex-col xl:space-y-2 xl:space-x-0 space-x-2 h-full overflow-hidden overflow-x-auto xl:overflow-y-auto custom-scrollbar">
                {images.map((image, index) => (
                    <img
                        key={index}
                        src={image.url || NoImage}
                        alt={`Thumbnail ${index}`}
                        className="w-full h-[92px] sm:h-[72px] md:h-[102px] lg:h-[142px] object-cover cursor-pointer rounded-md"
                        onClick={() => setCurrentIndex(index)}
                    />
                ))}
              </div>
          )}
        </div>

        {isModalOpen && (
            <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75"
                onClick={closeModal}
            >
              <div className="relative">
                <img
                    src={mainImage}
                    onClick={(e) => e.stopPropagation()}
                    alt="Large view"
                    className="max-w-full max-h-screen"
                />
                <button
                    onClick={closeModal}
                    className="absolute top-2 right-2 text-white text-3xl font-bold"
                >
                  &times;
                </button>
                <button
                    onClick={handlePrev}
                    className="absolute left-2 top-1/2 transform -translate-y-1/2 text-white text-3xl font-bold bg-white bg-opacity-25 rounded-full px-2 pb-1 hover:bg-opacity-50"
                >
                  &#8249;
                </button>
                <button
                    onClick={handleNext}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2 text-white text-3xl font-bold bg-white bg-opacity-25 rounded-full px-2 pb-1 hover:bg-opacity-50"
                >
                  &#8250;
                </button>
              </div>
            </div>
        )}
      </>
  );
};

export default Gallery;
